/* Las pantallas que se cargan cuando hacen falta, y no antes.
 *
 * SALEN DE `App.js` EL 3 DE OCTUBRE DE 2026, y la razon es medible: App.js llevaba cincuenta
 * `lazy(...)` y el arbol de rutas en el mismo fichero, 399 lineas de 400, y la pantalla
 * siguiente —`/vuelve`— no cabia. Subirle el numero al portero del tamaño habria sido mentir
 * (lo dice su propia cabecera), asi que se parte por donde hay un tema: aqui, QUIEN se carga;
 * alli, CUANDO se entra.
 *
 * POR QUE SIGUEN SIENDO `lazy` Y NO IMPORTS NORMALES. Un alumno que entra a hacer un test no
 * tiene por que descargarse el mundo 3D, el laberinto ni el panel del administrador. Cada
 * `lazy` es un trozo que viaja solo la primera vez que alguien pisa esa ruta, y la espera la
 * cubre el `<Suspense>` de App.js. Convertir una de estas lineas en `import` de arriba no da
 * ningun error: da un primer arranque mas lento, que es la clase de averia que nadie ve.
 *
 * LO QUE **NO** VA AQUI: nada que se monte siempre (la barra, el pie, los avisos, el contador
 * de pantallas). Eso se importa en App.js de la forma normal, porque diferir algo que se
 * necesita en el primer pintado es pagar un viaje de red para nada.
 */
import { lazy } from "react";

export const Agora = lazy(() => import("@/pages/PortadaDelMundo"));
export const Dashboard = lazy(() => import("@/pages/Dashboard"));
export const AlphaLab = lazy(() => import("@/pages/AlphaLab"));
export const MisMateriales = lazy(() => import("@/pages/MisMateriales"));
export const Familia = lazy(() => import("@/pages/Familia"));
export const InformeSemanal = lazy(() => import("@/pages/InformeSemanal"));
export const Academia = lazy(() => import("@/pages/Academia"));
export const Metodologia = lazy(() => import("@/pages/Metodologia"));
export const Cursos = lazy(() => import("@/pages/Cursos"));
export const CursoDetail = lazy(() => import("@/pages/CursoDetail"));
export const MisRecuerdos = lazy(() => import("@/pages/MisRecuerdos"));
export const Lecturas = lazy(() => import("@/pages/Lecturas"));
export const Observatorio = lazy(() => import("@/pages/Observatorio"));
export const Ajustes = lazy(() => import("@/pages/Ajustes"));
export const TuMentor = lazy(() => import("@/pages/TuMentor"));
export const Legal = lazy(() => import("@/pages/Legal"));
export const TutorConfirma = lazy(() => import("@/pages/TutorConfirma"));
export const InvitacionAcepta = lazy(() => import("@/pages/InvitacionAcepta"));
export const Newsletter = lazy(() => import("@/pages/Newsletter"));
export const NewsletterArticle = lazy(() => import("@/pages/NewsletterArticle"));
export const Contacto = lazy(() => import("@/pages/Contacto"));
// La pantalla del correo de despedida del instituto. Se llega por el correo y por nada
// mas -esta declarada en `tools/check_rutas.py`-, asi que diferirla no le cuesta una
// espera a nadie: quien la abre viene de fuera y carga esa pagina y ninguna otra.
export const Vuelve = lazy(() => import("@/pages/Vuelve"));
// La pagina que abre el ADULTO desde el enlace para casa (B3.1). Publica: quien paga no tiene cuenta.
export const Pagar = lazy(() => import("@/pages/Pagar"));
export const BossBattle = lazy(() => import("@/pages/BossBattle"));
// LA PUERTA DE PRUEBA DEL JEFE. Solo se monta si la compilacion lleva REACT_APP_JEFE_PRUEBA=1:
// en produccion la variable no esta y la ruta no existe, asi que nadie se salta las lecciones.
// Para quitarla del todo, se borra JefePrueba.jsx y estas lineas.
export const JEFE_PRUEBA = process.env.REACT_APP_JEFE_PRUEBA === "1";
export const JefePrueba = lazy(() => import("@/pages/JefePrueba"));
export const Test = lazy(() => import("@/pages/Test"));
export const Tests = lazy(() => import("@/pages/Tests"));
export const Resultados = lazy(() => import("@/pages/Resultados"));
export const Precios = lazy(() => import("@/pages/Precios"));
export const Login = lazy(() => import("@/pages/Login"));
export const Register = lazy(() => import("@/pages/Register"));
export const ClaveOlvidada = lazy(() => import("@/pages/ClaveOlvidada"));
export const ClaveNueva = lazy(() => import("@/pages/ClaveNueva"));
export const LessonView = lazy(() => import("@/pages/LessonView"));
// El modo aula. `AulaLeccion` no se carga aqui: la carga `Aula` cuando el alumno elige
// una, y no tiene ruta propia (el porque, escrito en su propia cabecera).
export const Aula = lazy(() => import("@/pages/Aula"));
export const JourneyMap = lazy(() => import("@/pages/JourneyMap"));
// UNA SOLA PAGINA PARA LOS DOS SITIOS (U4). Las dos rutas siguen existiendo -son enlaces
// que la gente ya tiene- pero ensenan el MISMO mundo empezando en sitios distintos. Cruzar
// de uno a otro ya no es navegar: es andar.
// EL MUNDO SEGÚN LA PANTALLA (10 oct 2026): en el ordenador el de siempre, en el móvil tumbado a
// pantalla completa con joystick, y de pie lo que llevas. El 3D sigue entrando por `lazy()` dentro.
export const Mundo = lazy(() => import("@/pages/MundoSegunPantalla"));
// EL LABERINTO ES PANTALLA PROPIA Y NO UN SITIO DEL MUNDO: al laberinto se BAJA, y meterlo
// en la escena de la Explanada habria obligado a tocar el suelo, la camara y `createMundo` para
// ganar una continuidad que aqui no hace falta. El porque entero, en `docs/estado/laberinto.md`.
export const Laberinto = lazy(() => import("@/pages/Laberinto"));
export const AvatarCreator = lazy(() => import("@/pages/AvatarCreator"));
export const AdminCMS = lazy(() => import("@/pages/admin/AdminCMS"));
export const CmsCourseEditor = lazy(() => import("@/pages/admin/CmsCourseEditor"));
export const JourneyEditor = lazy(() => import("@/pages/admin/JourneyEditor"));
export const CmsImport = lazy(() => import("@/pages/admin/CmsImport"));
export const Cofres = lazy(() => import("@/pages/Cofres"));
export const AdminAnalytics = lazy(() => import("@/pages/admin/AdminAnalytics"));
export const AdminResources = lazy(() => import("@/pages/admin/AdminResources"));
// La ficha de un alumno (13 oct 2026). Diferida por lo mismo que los permisos: la abre una persona.
export const FichaDeAlumno = lazy(() => import("@/pages/admin/FichaDeAlumno"));
// Comunicados (13 oct 2026): el correo a todas las cuentas y los Directos. Lo abre una persona.
export const Comunicados = lazy(() => import("@/pages/admin/Comunicados"));
// Los permisos de tutor de los menores de catorce. Diferida como las demas, y ademas la
// ve una persona al dia: cargarla en el arranque de todos los alumnos seria pagar un
// viaje de red por cada uno para una pantalla que no van a abrir nunca.
export const PermisosDeTutor = lazy(() => import("@/pages/admin/PermisosDeTutor"));
export const ProfesorPanel = lazy(() => import("@/pages/ProfesorPanel"));
// La ficha de un alumno vista por su profesor (18 oct 2026): la del admin, con otra fuente.
export const FichaDeMiAlumno = lazy(() => import("@/pages/profesor/FichaDeMiAlumno"));
export const AdminCommunities = lazy(() => import("@/pages/admin/AdminCommunities"));
export const AdminCommunityDetail = lazy(() => import("@/pages/admin/AdminCommunityDetail"));
export const CommunityDetail = lazy(() => import("@/pages/CommunityDetail"));
export const FinDeAcceso = lazy(() => import("@/pages/FinDeAcceso"));
// El viaje de la Insignia: el chat del origen, al que sólo se llega desde su cabina (21 oct 2026).
export const ViajeAlOrigen = lazy(() => import("@/pages/ViajeAlOrigen"));
// LA CEREMONIA DE NIVEL no es una pantalla, pero llega un momento después por el mismo motivo
// que el mentor flotante de App.js, y con una razón de más: arrastra `SubidaDeNivel` y con él el
// avatar entero —la Estrella, el cuerpo—, que son treinta y cinco kilos de dibujo que la portada
// no pinta. En directo entró en la primera carga y `prueba_primeraCarga.mjs` lo paró en el acto:
// el avatar se aplaza en todas partes y esto lo metía por la puerta de delante.
// No se nota: el trozo sale a buscarse en cuanto pinta la primera pantalla y la ceremonia no
// aparece hasta que alguien sube de nivel, que son muchos segundos después como pronto.
// (Vino de App.js el 21 oct 2026, que pasaba de las 400 líneas.)
export const CeremoniaDeNivel = lazy(() => import("@/components/CeremoniaDeNivel"));
// EL OJO DE ARGOS, el juego de Ariadna (M10). Aplazado como todas: es una pantalla entera
// con su lienzo, y no la abre nadie hasta que se entra por el agujero del mundo.
export const ElOjo = lazy(() => import("@/pages/ElOjo"));
